import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SummaryListItem from './SummaryListItem';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';

const SummaryList = props => {
  const { itemsList, setHighlightedWardrobe } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { setActiveWardrobe } = useContext(ActiveWardrobeContext);
  const setProduct = product => {
    const wardrobeIndex = Object.keys(wardrobesConfigs).find(
      key => wardrobesConfigs[key] === product,
    );
    setActiveWardrobe(parseInt(wardrobeIndex));

    const popup = document.querySelector(`[data-popup-name="summary-wardrobe-popup"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  return (
    <div className="summary">
      <ul className="summary-list">
        {Object.keys(itemsList).map((key, index) => (
          <SummaryListItem
            product={itemsList[key]}
            key={`summary-item-${index}`}
            setProduct={setProduct}
            setHighlightedWardrobe={setHighlightedWardrobe}
            index={index}
          />
        ))}
      </ul>
    </div>
  );
};

SummaryList.propTypes = {
  itemsList: PropTypes.array.isRequired,
};

export default SummaryList;
